import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getColumnOrder, getJsonSettingsByKey, TableSettingsButton } from '../../components/v2/table-settings-button'

export function useInvoiceColumns<T extends { key: string; title: React.ReactNode }>(settingsKey: string, columns: T[], defaults: string[], allColumnsLabel = 'Все колонки') {
  const settings: any = useSelector(state => getJsonSettingsByKey(state, settingsKey))
  const keys = columns.map(column => column.key)
  const saved = getColumnOrder(settings).filter(key => keys.includes(key))
  const selected = saved.length ? saved : defaults.filter(key => keys.includes(key))
  const visible = useMemo(() => selected.map(key => columns.find(column => column.key === key)!).filter(Boolean), [columns, selected.join(',')])
  const control = <TableSettingsButton
    settingsKey={settingsKey}
    items={columns.map(column => ({ key: column.key, title: column.title }))}
    mainKeys={defaults}
    initialKeys={defaults}
    allColumnsLabel={allColumnsLabel}
  />
  return { columns: visible, control }
}
